import LinkListSection from "../../components/Footer/components/LinkListSection";
import LinkList from "../../components/Footer/components/LinkListSection/components/LinkList";
import LinkListItem from "../../components/Footer/components/LinkListSection/components/LinkListItem";
import GridItem from "../../components/general/GridItem";
import { getUrlFromStoryblokLink } from "../../utils/storyblok/urls";

const LinkListsModule = ({ link_lists }: Queries.LinkListsModuleFragment) => {
	return link_lists ? (
		<GridItem>
			<LinkListSection>
				{link_lists.map((list, index) => (
					<LinkList key={`${list?._uid}-${index}`} title={list?.title || ""}>
						{list &&
							list.links?.map((link, index) => (
								<LinkListItem
									key={`${link?.label}-${index}`}
									target={link?.link?.target}
									linkText={link?.label || ""}
									anchor={link?.link?.anchor ?? undefined}
									href={getUrlFromStoryblokLink(link?.link)}
									inModule
								/>
							))}
					</LinkList>
				))}
			</LinkListSection>
		</GridItem>
	) : null;
};

export default LinkListsModule;
